import { QueryStringFilter } from '../../../models/query-string.model'
import { RoleSearchField, RoleSearchParams } from '../models/role-search.model'

/**
 * Parse role filter params
 * @param params - the search params
 * @param filter - the filter to parse
 * @returns the role search params updated
 */
export function roleFilterParams(
  params: RoleSearchParams,
  filter: QueryStringFilter<RoleSearchField>,
): RoleSearchParams {
  const searchParams: RoleSearchParams = {}

  switch (filter.field) {
    case 'code':
      if (filter.operator === '=') {
        searchParams.code = filter.value
      }
      break
    case 'label':
      if (filter.operator === 'contains') {
        searchParams['label:ct'] = filter.value
      } else if (filter.operator === '=') {
        searchParams['label'] = filter.value
      }
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}
